/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-21 21:11:45
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { BsyUtils } from "../../utils/Utils";
import BsyAlert from "../BsyAlert";
import BsyCheckGroup from "../BsyCheckGroup";
import BsyExcelGrid from "../BsyExcelGrid";
import BsyIconBtn from "../BsyIconBtn";
import BsySelect from "../BsySelect";
import BsySLoading from "../BsySLoading";
import BsyStepPane from "../BsyStepPane";
import BsyTextEditor from "../BsyTextEditor";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import { BsyConfig } from "../../global/BsyConfig";

export default class BsyImportPane extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-import-pane",
    currentStep: 0,
    status: "selectExcel", // dataPreview formSet importData
    authGroupId: null,
    name: "",
    importMode: 0,
    formItems: [],
    importCheckallowBlank: false,
    importCheckrepeat: false,
    importStartFlow: false,
    hasFlow: false,
    hasSubform: false,
    importDataExtendSet: {
      enable: false,
      datahelpids: [],
    },
    importData: {},
    sheet: null,
    fileinfo: {},
    // items: [],
    // heads: [],
    matchHead: { heads: [], items: [] },
    getSample: { heads: [], items: [] },
    isLoading: false,
    hasError: false,
    appType: 0,
  };
  constructor(props) {
    super(props);
    this.state = {
      steps: [
        React.language("import.excel.select"),
        React.language("etl.stage.preview"),
        React.language("form.config.ext"),
        React.language("import.excel.data"),
      ],
      ...props,
    };

    this.element = React.createRef();
    this.extendSetElement = React.createRef();
    this.nextImport = React.createRef();
    this.excelGridIndex = 1;
    this._initFormItems();
  }

  _initFormItems = () => {
    var a = this.options,
      b = this;
    this.formItems = [];
    this.widgetsMap = {};
    BsyUtils.forEach(a.formItems, function (a, c) {
      if (!(BsyConfig().LimitFields.import.indexOf(c.widget.type) < 0)) {
        if ("subform" === c.widget.type) {
          b.widgetsMap[c.widget.widgetName] = {
            field: c.widget.widgetName,
            noRepeat: c.widget.noRepeat,
            allowBlank: c.widget.allowBlank,
            text: c.label,
            type: c.widget.type,
            items: [],
          };
          BsyUtils.forEach(c.widget.items, function (a, d) {
            if (
              BsyConfig().LimitFields.import.indexOf(d.widget.type) > -1
            ) {
              if (d.widget.type === "address" || d.widget.type === "location") {
                var d1 = [
                  {
                    v: "province",
                    t: React.language("widget.address.province.withMark"),
                  },
                  {
                    v: "city",
                    t: React.language("city.withMark"),
                  },
                  {
                    v: "district",
                    t: React.language("widget.address.district.withMark"),
                  },
                ];
                d.widget.needDetail &&
                  d1.push({
                    v: "detail",
                    t: React.language("widget.address.detail.withMark"),
                  });
                b.widgetsMap[d.widget.widgetName] = {
                  field: d.widget.widgetName,
                  type: d.widget.type,
                  noRepeat: d.widget.noRepeat,
                  allowBlank: d.widget.allowBlank,
                  subform: c.widget.widgetName,
                };
                BsyUtils.forEach(d1, function (a1, d1) {
                  var e = [d.widget.widgetName, d1.v].join("-");
                  b.formItems.push({
                    value: e,
                    text: [c.label, d.label].join(".") + d1.t,
                  });
                  b.widgetsMap[e] = {
                    field: d.widget.widgetName,
                    type: d.widget.type,
                    noRepeat: d.widget.noRepeat,
                    allowBlank: d.widget.allowBlank,
                    subform: c.widget.widgetName,
                    part: d1.v,
                  };
                });
              } else {
                b.widgetsMap[d.widget.widgetName] = {
                  type: d.widget.type,
                  noRepeat: d.widget.noRepeat,
                  allowBlank: d.widget.allowBlank,
                  field: d.widget.widgetName,
                  text: d.label,
                  subform: c.widget.widgetName,
                };
                b.widgetsMap[c.widget.widgetName].items.push(
                  b.widgetsMap[d.widget.widgetName]
                );
                if (d.widget.type === "combo" || d.widget.type === "combocheck") {
                  if (d.widget.async) {
                    b.widgetsMap[d.widget.widgetName].async = d.widget.async;
                  } else {
                    b.widgetsMap[d.widget.widgetName].items = b._extSelected(
                      d.widget.items
                    );
                  }
                } else if (
                  d.widget.type === "radiogroup" ||
                  d.widget.type === "checkboxgroup"
                ) {
                  b.widgetsMap[d.widget.widgetName].items = b._extSelected(
                    d.widget.items
                  );
                } else if (d.widget.type === "datetime") {
                  b.widgetsMap[d.widget.widgetName].format = d.widget.format;
                }

                b.formItems.push({
                  value: d.widget.widgetName,
                  text: [c.label, d.label].join("."),
                });
              }
            }
          });
        } else if ("address" === c.widget.type) {
          var d = [
            {
              v: "province",
              t: React.language("widget.address.province.withMark"),
            },
            {
              v: "city",
              t: React.language("city.withMark"),
            },
            {
              v: "district",
              t: React.language("widget.address.district.withMark"),
            },
          ];
          c.widget.needDetail &&
            d.push({
              v: "detail",
              t: React.language("widget.address.detail.withMark"),
            });
          b.widgetsMap[c.widget.widgetName] = {
            field: c.widget.widgetName,
            noRepeat: c.widget.noRepeat,
            allowBlank: c.widget.allowBlank,
            type: c.widget.type,
          };
          BsyUtils.forEach(d, function (a, d) {
            var e = [c.widget.widgetName, d.v].join("-");
            b.formItems.push({
              value: e,
              text: c.label + d.t,
            });
            b.widgetsMap[e] = {
              field: c.widget.widgetName,
              noRepeat: c.widget.noRepeat,
              allowBlank: c.widget.allowBlank,
              type: c.widget.type,
              part: d.v,
            };
          });
        } else {
          if ("subform" !== c.widget.type) {
            b.formItems.push({
              value: c.widget.widgetName,
              text: c.label,
            });
            b.widgetsMap[c.widget.widgetName] = {
              field: c.widget.widgetName,
              noRepeat: c.widget.noRepeat,
              allowBlank: c.widget.allowBlank,
              text: c.label,
              type: c.widget.type,
            };
          }

          if (c.widget.type === "combo" || c.widget.type === "combocheck") {
            if (c.widget.async) {
              b.widgetsMap[c.widget.widgetName].async = c.widget.async;
            } else {
              b.widgetsMap[c.widget.widgetName].items = b._extSelected(
                c.widget.items
              );
            }
          } else if (
            c.widget.type === "radiogroup" ||
            c.widget.type === "checkboxgroup"
          ) {
            b.widgetsMap[c.widget.widgetName].items = b._extSelected(
              c.widget.items
            );
          } else if (c.widget.type === "datetime") {
            b.widgetsMap[c.widget.widgetName].format = c.widget.format;
          }
        }
      }
    });
  };
  _extSelected = (items) => {
    var bb = [];
    BsyUtils.forEach(items, function (a1, b1) {
      if (b1.hasOwnProperty("selected")) {
        delete b1.selected;
      }
      bb.push(b1);
    });
    return bb;
  };

  componentDidMount() {
    super.componentDidMount();
    let that = this;
    this.setState({
      importStartFlow: BsyUtils.Store.get(this._getimportStartFlowKey()),
    });
    setTimeout(() => {
      that.renderDataExtendSet();
    }, 200);
  }

  _getUploadSize = () => {
    return window.FX.Vip.getExcelMFS() / 1024 / 1024;
  };

  _saveDatahelp = () => {
    if (this.props.authGroupId !== null) return;

    var datahelpers = window.FX.STATIC.datahelpers;
    var datahelpers_remove = window.FX.STATIC.datahelpers_remove;

    React.axios(
      "/dashboard/app/" +
      window.FX.STATIC.APPID +
      "/entry/" +
      window.FX.STATIC.ENTRYID +
      "/importset",
      {
        formId: this.props.formId,
        authGroupId: this.props.authGroupId,
        importDataExtendSet: this.importDataExtendSet,
        datahelpers: datahelpers,
        datahelpers_remove: datahelpers_remove,
        extDashData: this.props.extDashData,
      }
    )
      .then((res) => {
        // BsyUtils.redirectTo(res.data.url)
      })
      .catch((res) => {
        console.error(res);
      });
  };

  renderDataExtendSet = () => {
    const { entryId, appId, appType } = this.state;
    let that = this;
    if (this.extendSetElement && this.extendSetElement.current) {
      window.$(this.extendSetElement.current).empty();

      if (this.importDataExtendSet) {
        if (this.props.ignoreAuth || (appType === 4 && BsyUtils.hasTokenEdit(appId))) {
          new window.FX.DataHelperBtn({
            renderEl: window.$(this.extendSetElement.current).empty(),
            style: "white",
            width: 280,
            height: "auto",
            extendType: "import",
            datahelpids: this.importDataExtendSet.datahelpids,
            formId: this.state.formId,
            visible: this.importDataExtendSet.enable,
            onStopEdit: function (e) {
              that.importDataExtendSet.datahelpids = e;
              that.importDataExtendSet.enable = true;
              that.setState(
                {
                  importDataExtendSet: that.importDataExtendSet,
                },
                () => {
                  that.renderDataExtendSet();
                  that._saveDatahelp();
                }
              );
            },
          });
        } else {
          var ss = [];
          BsyUtils.forEach(
            that.importDataExtendSet
              ? that.importDataExtendSet.datahelpids
              : [],
            function (a1, b1) {
              if (window.FX.STATIC.datahelpers[b1])
                ss.push(window.FX.STATIC.datahelpers[b1].name);
            }
          );
          window.$(this.extendSetElement.current).text(ss.join("、"));
        }
        return;
      }
      this.isLoading = true;
      React.axios(`/dashboard/app/${appId}/entry/${entryId}/importget`, {
        extDashData: this.props.extDashData,
      })
        .then((res) => {
          if (BsyUtils.isObjectEmpty(res.data)) {
            // let importDataExtendSet = this.state.importDataExtendSet;
            // importDataExtendSet.enable = !importDataExtendSet.enable
            // this.setState({
            //     importDataExtendSet: importDataExtendSet
            // })
            this.importDataExtendSet = {};
            window.FX.STATIC.datahelpers = {};
            if (this.props.ignoreAuth || (appType === 4 && BsyUtils.hasTokenEdit(appId))) {
              new window.FX.DataHelperBtn({
                renderEl: window.$(this.extendSetElement.current).empty(),
                style: "white",
                width: 280,
                height: "auto",
                extendType: "import",
                datahelpids: this.importDataExtendSet.datahelpids,
                formId: this.state.formId,
                visible: this.importDataExtendSet.enable,
                onStopEdit: function (e) {
                  that.importDataExtendSet.datahelpids = e;
                  that.importDataExtendSet.enable = true;

                  that.setState(
                    {
                      importDataExtendSet: that.importDataExtendSet,
                    },
                    () => {
                      that.renderDataExtendSet();
                      that._saveDatahelp();
                    }
                  );
                },
              });
            }
          } else {
            this.importDataExtendSet = BsyUtils.isObjectEmpty(
              res.data.importDataExtendSet
            )
              ? {}
              : res.data.importDataExtendSet;
            window.FX.STATIC.datahelpers = res.data.datahelpers;
            this.setState(
              {
                importDataExtendSet: that.importDataExtendSet
                  ? that.importDataExtendSet
                  : this.props.importDataExtendSet,
              },
              () => {
                if (this.props.ignoreAuth || (appType === 4 && BsyUtils.hasTokenEdit(appId))) {
                  new window.FX.DataHelperBtn({
                    renderEl: window.$(this.extendSetElement.current).empty(),
                    style: "white",
                    width: 280,
                    height: "auto",
                    extendType: "import",
                    datahelpids: this.importDataExtendSet.datahelpids,
                    formId: this.state.formId,
                    visible: this.importDataExtendSet.enable,
                    onStopEdit: function (e) {
                      that.importDataExtendSet.datahelpids = e;
                      that.importDataExtendSet.enable = true;
                      that.setState(
                        {
                          importDataExtendSet: that.importDataExtendSet,
                        },
                        () => {
                          that.renderDataExtendSet();
                          that._saveDatahelp();
                        }
                      );
                    },
                  });
                } else {
                  var ss = [];
                  BsyUtils.forEach(
                    that.importDataExtendSet
                      ? that.importDataExtendSet.datahelpids
                      : [],
                    function (a1, b1) {
                      if (window.FX.STATIC.datahelpers[b1]) {
                        if (
                          window.FX.STATIC.datahelpers[b1].hasOwnProperty(
                            "datahelperenable"
                          )
                        ) {
                          if (
                            window.FX.STATIC.datahelpers[b1].datahelperenable
                          ) {
                            ss.push(window.FX.STATIC.datahelpers[b1].name);
                          }
                        } else {
                          ss.push(window.FX.STATIC.datahelpers[b1].name);
                        }
                      }
                    }
                  );

                  window.$(this.extendSetElement.current).text(ss.join("、"));
                }
              }
            );
          }
        })
        .catch((res) => {
          console.error(res);
        });
    }
  };

  downTemplte = () => {
    React.axios("/data/_list/excel_template", {
      formId: this.props.formId,
      appId: this.props.appId,
      entryId: this.props.entryId,
      extDashData: this.props.extDashData,
      authGroupId: this.props.authGroupId,
    })
      .then((res) => {
        BsyUtils.redirectTo(res.data.url);
      })
      .catch((res) => {
        console.error(res);
      });
  };

  _getimportStartFlowKey = () => {
    return BsyUtils.Store.getKey("importStartFlow", {
      appId: this.props.appId,
      entryId: this.props.entryId,
    });
  };

  excelGetSample = () => {
    const { appId, fileinfo, authGroupId, entryId, sheet } = this.state;
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.setState({
      isLoading: true,
    });

    React.axios("/dashboard/app/" + appId + "/excel/get_sample", {
      authGroupId: authGroupId,
      cacheKey: fileinfo.cacheKey,
      entryId: entryId,
      sheetName: sheet || fileinfo.sheetList[0],
      extDashData: this.props.extDashData,
      count: 30,
      skip: 0,
    })
      .then((res) => {
        this.isLoading = false;
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            this.setState({
              currentStep: 1,
              isLoading: false,
              status: "dataPreview",
              hasSubform: res.data.hasSubform,
              getSample: {
                items: res.data.sample ? [...res.data.sample] : [],
                heads: res.data.columns ? [...res.data.columns] : [],
              },
            });
          },
          () => {
            this.setState({
              currentStep: 0,
              status: "selectExcel",
              fileinfo: {},
              sample: {},
              isLoading: false,
            });
          }
        );
      })
      .catch((res) => {
        this.setState({
          isLoading: false,
        });
        this.isLoading = false;
        console.error(res);
      });
  };

  excelMatchHead = () => {
    const { appId, fileinfo, authGroupId, entryId, sheet, importMode } =
      this.state;

    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.setState({
      isLoading: true,
    });
    React.axios("/dashboard/app/" + appId + "/excel/match_head", {
      authGroupId: authGroupId,
      cacheKey: fileinfo.cacheKey,
      entryId: entryId,
      sheetName: sheet || fileinfo.sheetList[0],
      baseRow: 0,
      importMode: importMode,
      extDashData: this.props.extDashData,
      count: 30,
      skip: 0,
    })
      .then((res) => {
        this.isLoading = false;
        this.setState({
          currentStep: 2,
          isLoading: false,
          status: "formSet",
          hasSubform: res.data.hasSubform,
          matchHead: {
            items: res.data.sample ? [...res.data.sample] : [],
            heads: res.data.columns ? [...res.data.columns] : [],
          },
        });
        if (res.data.code === 3000) {
          tipAlert({
            type: "warning",
            msg: res.data.msg,
          });
        }
      })
      .catch((res) => {
        this.setState({
          isLoading: false,
        });
        this.isLoading = false;
        console.error(res);
      });
  };

  excelCheckData = () => {
    const {
      appId,
      fileinfo,
      authGroupId,
      entryId,
      sheet,
      importMode,
      importCheckallowBlank,
      importStartFlow,
      importCheckrepeat,
    } = this.state;
    let that = this;

    if (importMode === 1 || importMode === 2) {
      var select_dataid = false;
      BsyUtils.forEach(that.columnMatch, function (a1, b1) {
        if (b1.match.field === "_id") {
          select_dataid = true;
        }
      });
      if (!select_dataid) {
        tipAlert({
          type: "warning",
          msg: React.language("error.4319"),
        });
        return;
      }
      BsyAlert({
        title:
          importMode === 1
            ? React.language("import.update.confirm")
            : React.language("import.upsert.confirm"),
        msg:
          importMode === 1
            ? React.language("import.update.confirm.tip")
            : React.language("import.upsert.confirm.tip"),
        type: "warning",
        OkType: "blue",
        text4Ok: React.language("ok"),
        text4Cancel: React.language("cancel"),
        ok: () => {
          if (this.isLoading) return;
          this.isLoading = true;
          this.setState({
            isLoading: true,
          });

          React.axios("/dashboard/app/" + appId + "/excel/check_data", {
            authGroupId: authGroupId,
            cacheKey: fileinfo.cacheKey,
            entryId: entryId,
            sheetName: sheet || fileinfo.sheetList[0],
            baseRow: 0,
            importCheckallowBlank: importCheckallowBlank,
            importCheckrepeat: importCheckrepeat,
            importMode: importMode,
            importStartFlow: importStartFlow,
            columnMatch: that.columnMatch,
            extDashData: that.props.extDashData,
          })
            .then((res) => {
              this.isLoading = false;
              if (res.data.errorCount + res.data.checkErrorCount === 0) {
                that.excelImport();
              } else {
                that.errorData = { ...res.data };
                that.setState({
                  currentStep: 2,
                  hasError: that.errorData.checkErrorCount > 0 ? true : false,
                  isLoading: false,
                  status: "checkData",
                });
              }
            })
            .catch((res) => {
              this.isLoading = false;
              this.setState({
                isLoading: false,
              });
              console.error(res);
            });
          return !0;
        },
      });

      return;
    }

    if (this.isLoading) return;
    this.isLoading = true;
    this.setState({
      isLoading: true,
    });

    React.axios("/dashboard/app/" + appId + "/excel/check_data", {
      authGroupId: authGroupId,
      cacheKey: fileinfo.cacheKey,
      entryId: entryId,
      sheetName: sheet || fileinfo.sheetList[0],
      baseRow: 0,
      importCheckallowBlank: importCheckallowBlank,
      importCheckrepeat: importCheckrepeat,
      importMode: importMode,
      importStartFlow: importStartFlow,
      columnMatch: this.columnMatch,
      extDashData: this.props.extDashData,
    })
      .then((res) => {
        this.isLoading = false;
        if (res.data.errorCount + res.data.checkErrorCount === 0) {
          this.excelImport();
        } else {
          this.errorData = { ...res.data };
          this.setState({
            currentStep: 2,
            isLoading: false,
            hasError: that.errorData.checkErrorCount > 0 ? true : false,
            status: "checkData",
          });
        }
      })
      .catch((res) => {
        this.setState({
          isLoading: false,
        });
        this.isLoading = false;
        console.error(res);
      });
  };

  excelImport = () => {
    const {
      appId,
      fileinfo,
      authGroupId,
      entryId,
      sheet,
      importMode,
      importCheckallowBlank,
      importStartFlow,
      importCheckrepeat,
      hasFlow,
      importDataExtendSet,
    } = this.state;
    const { errorData } = this;
    let that = this;

    let fixedDataList = {};

    //this.checkDataExcelGridContext
    if (errorData && errorData.checkErrorCount + errorData.errorCount > 0) {
      let dt = [0, {}];
      if (this.checkDataExcelGridContext) {
        dt = this.checkDataExcelGridContext.getFixedDataList();
      } else {
        dt = [errorData.checkErrorCount + errorData.errorCount, {}];
      }

      if (dt[0] > 0) {
        BsyAlert({
          title: React.language("import.excel.data"),
          msg: React.language("import.warning.tip", {
            count: dt[0],
          }),
          type: "warning",
          text4Ok: React.language("ok"),
          text4Cancel: React.language("cancel"),
          ok: () => {
            if (this.isLoading) return;
            this.isLoading = true;
            this.setState({
              isLoading: true,
            });

            fixedDataList = dt[1];
            React.axios("/dashboard/app/" + appId + "/excel/import", {
              authGroupId: authGroupId,
              cacheKey: fileinfo.cacheKey,
              entryId: entryId,
              sheetName: sheet || fileinfo.sheetList[0],
              baseRow: 0,
              fixedDataList: fixedDataList,
              importCheckallowBlank: importCheckallowBlank,
              importCheckrepeat: importCheckrepeat,
              importDataExtendSet: importDataExtendSet,
              importMode: importMode,
              importStartFlow: importStartFlow,
              columnMatch: that.columnMatch,
              extDashData: that.props.extDashData,
            })
              .then((res) => {
                this.isLoading = false;
                that.setState(
                  {
                    currentStep: 3,
                    isLoading: false,
                    status: "importData",
                    importData: { ...res.data },
                  },
                  () => {
                    if (
                      hasFlow &&
                      importMode === 0 &&
                      importStartFlow &&
                      res.data.flowData &&
                      res.data.flowData.length > 0
                    ) {
                      that.excelStartFlow(
                        res.data.flowData,
                        res.data.dataCount
                      );
                    }
                  }
                );
              })
              .catch((res) => {
                this.setState({
                  isLoading: false,
                });
                this.isLoading = false;
                console.error(res);
              });
            return !0;
          },
        });
        return;
      }

      fixedDataList = dt[1];
    }
    if (this.isLoading) return;
    this.isLoading = true;
    this.setState({
      isLoading: true,
    });

    React.axios("/dashboard/app/" + appId + "/excel/import", {
      authGroupId: authGroupId,
      cacheKey: fileinfo.cacheKey,
      entryId: entryId,
      sheetName: sheet || fileinfo.sheetList[0],
      baseRow: 0,
      fixedDataList: fixedDataList,
      importCheckallowBlank: importCheckallowBlank,
      importCheckrepeat: importCheckrepeat,
      importDataExtendSet: importDataExtendSet,
      importMode: importMode,
      importStartFlow: importStartFlow,
      columnMatch: this.columnMatch,
      extDashData: this.props.extDashData,
    })
      .then((res) => {
        this.isLoading = false;
        this.setState(
          {
            currentStep: 3,
            isLoading: false,
            status: "importData",
            importData: { ...res.data },
          },
          () => {
            if (
              hasFlow &&
              importMode === 0 &&
              importStartFlow &&
              res.data.flowData &&
              res.data.flowData.length > 0
            ) {
              this.excelStartFlow(res.data.flowData, res.data.dataCount);
            }
          }
        );
      })
      .catch((res) => {
        this.setState({
          isLoading: false,
        });
        this.isLoading = false;
        console.error(res);
      });
  };

  excelStartFlow = (flowData, dataCount) => {
    const { appId, authGroupId, entryId, name } = this.state;

    window.FX.Msg.notice({
      title: React.language("import.excel.flowAsync"),
      type: "async",
      duration: 3000,
    });

    React.axios("/dashboard/app/" + appId + "/excel/startflow", {
      authGroupId: authGroupId,
      entryId: entryId,
      formId: entryId,
      flowDataId: flowData,
      extDashData: this.props.extDashData,
    })
      .then((res) => {
        let i = res.data.failure;
        let a = res.data.success;
        let n =
          0 === i
            ? "import.excel.flowAsync.success"
            : "import.excel.flowAsync.fail";

        window.FX.Msg.notice({
          title: React.language("import.excel.flowAsync.title", {
            count: dataCount,
            name: name,
          }),
          type: "success",
          duration: 0,
          content: window.$('<div class="excel-import-notice-content"/>').html(
            React.language(n, {
              success: '<span class="success">' + a + "</span>",
              fail: '<span class="fail">' + i + "</span>",
            })
          ),
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  excelUpload = (e) => {
    const { appId } = this.state;
    let file = e.target.files[0];

    if (file.size === 0) {
      tipAlert({
        msg: React.language("upload.maxLimitTip0"),
        type: "warning",
      });
      return;
    }

    if (file.size > BsyUtils.Vip.getExcelMFS()) {
      tipAlert({
        msg: React.language("upload.maxLimitTip"),
        type: "warning",
      });
      return;
    }

    let param = new FormData();
    param.append("file", file);
    let config = {
      headers: { "Content-Type": "multipart/form-data" },
    };
    this.setState({
      isLoading: true,
    });
    React.axios("/dashboard/app/" + appId + "/excel/upload", param, config)
      .then((res) => {
        this.isLoading = false;
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            this.setState(
              {
                currentStep: 1,
                status: "dataPreview",
                isLoading: false,
                fileinfo: { ...res.data.file },
              },
              () => {
                this.excelGetSample();
              }
            );
          },
          () => {
            this.setState({
              isLoading: false,
            });
          }
        );
      })
      .catch((res) => {
        this.isLoading = false;
        this.setState({
          isLoading: false,
        });
        console.error(res);
      });
  };

  renderSelectExcel = () => {
    const {
      importMode,
      importCheckallowBlank,
      importCheckrepeat,
      importStartFlow,
      hasFlow,
      importDataExtendSet,
    } = this.state;
    let fieldv = [];
    if (importCheckallowBlank) {
      fieldv.push(0);
    }
    if (importCheckrepeat) {
      fieldv.push(1);
    }
    return (
      <div
        className={"content"}
        key={"renderSelectExcel" + this.excelGridIndex}
      >
        <div className={"import-content "}>
          <div className={"bsy-import-item"} style={{ paddingTop: 0 }}>
            <span className={"span-text"}>{React.language("import.mode")}</span>
            <BsySelect
              allowBlank={false}
              searchable={false}
              width={160}
              items={[
                {
                  value: 0,
                  text: React.language("import.mode.insert"),
                  selected: importMode === 0,
                },
                {
                  value: 1,
                  text: React.language("import.mode.update"),
                  selected: importMode === 1,
                },
                {
                  value: 2,
                  text: React.language("import.mode.upsert"),
                  selected: importMode === 2,
                },
              ]}
              onStopEdit={(val) => {
                this.setState(
                  {
                    importMode: val,
                  },
                  () => {
                    this.renderDataExtendSet();
                  }
                );
              }}
            ></BsySelect>
          </div>
          <div className={"bsy-import-item"}>
            <span className={"span-text"}>
              {React.language("data") + React.language("validate")}
            </span>
            <BsyCheckGroup
              layout={"horizontal"}
              value={fieldv}
              items={[
                {
                  value: 0,
                  text: React.language("required") + React.language("field"),
                },
                {
                  value: 1,
                  text:
                    React.language("field.noRepeat") + React.language("field"),
                },
              ]}
              onStopEdit={(e) => {
                let allowBlank = false;
                let repeat = false;
                if (e.indexOf(0) > -1) allowBlank = true;

                if (e.indexOf(1) > -1) repeat = true;

                this.setState(
                  {
                    importCheckallowBlank: allowBlank,
                    importCheckrepeat: repeat,
                  },
                  () => {
                    this.renderDataExtendSet();
                  }
                );
              }}
            ></BsyCheckGroup>
          </div>
          {hasFlow && (importMode === 0 || importMode === 2) && (
            <div className={"bsy-import-item"}>
              <span className={"span-text"}>
                {React.language("flow.launch")}
              </span>
              <BsyCheckGroup
                key={"startFlow" + new Date().getTime()}
                value={importStartFlow ? [0] : []}
                layout={"horizontal"}
                items={[
                  { value: 0, text: React.language("import.excel.flow") },
                ]}
                onStopEdit={(e) => {
                  let startFlow = false;
                  if (e.indexOf(0) > -1) startFlow = true;

                  this.setState(
                    {
                      importStartFlow: startFlow,
                    },
                    () => {
                      BsyUtils.Store.set(
                        this._getimportStartFlowKey(),
                        startFlow
                      );
                      this.renderDataExtendSet();
                    }
                  );
                }}
              ></BsyCheckGroup>
            </div>
          )}
          <div className={"bsy-import-item"}>
            <span className={"span-text"}>
              {React.language("datahelper.import.dataExt")}
            </span>
            <BsyCheckGroup
              key={"dataExt" + new Date().getTime()}
              layout={"horizontal"}
              value={importDataExtendSet.enable ? [0] : []}
              items={[
                {
                  value: 0,
                  text: React.language("datahelper.import.dataExt.open"),
                },
              ]}
              onStopEdit={(e) => {
                let extendSet = { ...importDataExtendSet };
                if (e.indexOf(0) > -1) extendSet.enable = true;
                else extendSet.enable = false;
                this.setState(
                  {
                    importDataExtendSet: extendSet,
                  },
                  () => {
                    this.renderDataExtendSet();
                  }
                );
              }}
            ></BsyCheckGroup>
            {!this.props.ignoreAuth ? (
              <span
                onMouseEnter={(e) => {
                  if (window.FX && window.FX.UI) {
                    window.FX.UI.showPopover({
                      position: "top",
                      anchor: window.$(e.currentTarget),
                      content: window
                        .$("<span />")
                        .text(React.language("datahelper.import.dataExt.tip")),
                      // type: "dark"
                    });
                  }
                }}
                onMouseLeave={() => {
                  if (window.FX && window.FX.UI) {
                    window.FX.UI.closePopover();
                  }
                }}
              >
                <i class="icon-bsy-help"></i>
              </span>
            ) : (
              ""
            )}
          </div>


          <div
            className={"bsy-import-item"}
            style={{
              paddingLeft: 200,
            }}
          >
            <div
              className={"dataExt " + (hasFlow ? "hasFlow" : "")}
              style={{
                display: importDataExtendSet.enable ? "inline-block" : "none",
                lineHeight: "30px",
              }}
              ref={this.extendSetElement}
            ></div>
          </div>



          <ul className="bsy-import-tip">
            <span className="title">{React.language("Excel.title.tip")}</span>
            <li>
              <div className="tip"></div>
              <span>{React.language("Excel.title.tip2")}</span>
              <span className="x-c-key" onClick={this.downTemplte}>
                {React.language("Excel.title.tip3")}
              </span>
              <span>{React.language("import.excel.data")}</span>
            </li>
            <li>
              <div className="tip"></div>
              <span>
                {React.language("Excel.title.tip7", {
                  size: this._getUploadSize(),
                })}
              </span>
            </li>
            <li>
              <div className="tip"></div>
              <span>{React.language("Excel.title.tip8")}</span>
            </li>
            {hasFlow && (
              <li className="flow_start">
                <div className="tip"></div>
                <span>{React.language("Excel.title.tip20")}</span>
              </li>
            )}
            {(importMode === 1 || importMode === 2) && (
              <li className="subform_update">
                <div className="tip"></div>
                <span>{React.language("Excel.title.tip21")}</span>
              </li>
            )}
          </ul>
        </div>

        <div className={"import-footer"}>
          <BsyIconBtn
            key={"btnselect" + this.excelGridIndex}
            text={React.language("select.file")}
            type={"blue"}
            file={true}
            accept={".xlsx,.xls"}
            onChange={(event) => {
              this.excelUpload(event);
            }}
            mode={window.mode}
          />
        </div>
      </div>
    );
  };

  renderDataPreview = () => {
    const { fileinfo, sheet, hasSubform, getSample } = this.state;
    let sheetItems = [];
    if (fileinfo.sheetList?.length) {
      for (let i = 0; i < fileinfo.sheetList.length; i++) {
        sheetItems.push({
          value: fileinfo.sheetList[i],
          text: fileinfo.sheetList[i],
        });
      }
    }
    return (
      <div
        className={"content"}
        key={"renderDataPreview" + this.excelGridIndex}
      >
        <div className={"import-content "}>
          <div className={"bsy-import-tool"}>
            <span className={"span-title"}>{React.language("excel")}</span>
            <BsySelect
              allowBlank={false}
              searchable={false}
              value={sheet || fileinfo.sheetList[0]}
              width={160}
              items={sheetItems}
              onStopEdit={(val) => {
                this.setState(
                  {
                    sheet: val,
                  },
                  () => {
                    this.excelGetSample();
                  }
                );
              }}
            ></BsySelect>
          </div>
          <div className="bsy-import-excel">
            <BsyExcelGrid
              key={"BsyExcelGrid-" + this.excelGridIndex}
              hasSubform={hasSubform}
              items={getSample.items}
              heads={getSample.heads}
              formId={this.props.formId}
            ></BsyExcelGrid>
          </div>
        </div>
        <div className={"import-footer"}>
          <BsyIconBtn
            key={"btnnextStep" + this.excelGridIndex}
            text={React.language("nextStep")}
            type={"blue"}
            click={(event) => {
              this.excelMatchHead();
            }}
            mode={window.mode}
          />
          <BsyIconBtn
            key={"btnprevStep" + this.excelGridIndex}
            text={React.language("prevStep")}
            click={(event) => {
              this.setState(
                {
                  currentStep: 0,
                  status: "selectExcel",
                  fileinfo: {},
                  sample: {},
                },
                () => {
                  this.renderDataExtendSet();
                }
              );
            }}
            mode={window.mode}
          />
        </div>
      </div>
    );
  };

  renderFormSet = () => {
    const {
      fileinfo,
      hasSubform,
      matchHead,
      name,
      importCheckallowBlank,
      importCheckrepeat,
      importMode,
    } = this.state;
    let sheetItems = [];
    let that = this;
    for (let i = 0; i < fileinfo.sheetList.length; i++) {
      sheetItems.push({
        value: fileinfo.sheetList[i],
        text: fileinfo.sheetList[i],
      });
    }
    return (
      <div className={"content"} key={"renderFormSet" + this.excelGridIndex}>
        <div className={"import-content "}>
          <div className={"bsy-import-tool"}>
            <span className={"span-title"}>{React.language("form.name")}</span>
            <BsyTextEditor
              enable={false}
              value={name}
              width={160}
              items={sheetItems}
            ></BsyTextEditor>
          </div>
          <div className="bsy-import-excel">
            <BsyExcelGrid
              getContext={(context) => {
                this.excelGridContext = context;
              }}
              key={"BsyExcelGrid-" + this.excelGridIndex}
              hasSubform={hasSubform}
              items={matchHead.items}
              heads={matchHead.heads}
              showHead={true}
              headEnable={true}
              matchWidgets={
                importMode === 1 || importMode === 2
                  ? [{ value: "_id", text: "data_id" }, ...this.formItems]
                  : this.formItems
              }
              widgetsMap={
                importMode === 1 || importMode === 2
                  ? { _id: { type: "text" }, ...this.widgetsMap }
                  : this.widgetsMap
              }
              formId={this.props.formId}
              onAsyncSuccess={() => {
                that.columnMatch = [
                  ...this.excelGridContext.getColumnMatch(
                    importCheckallowBlank,
                    importCheckrepeat
                  ),
                ];
              }}
            ></BsyExcelGrid>
          </div>
        </div>
        <div className={"import-footer"}>
          <BsyIconBtn
            key={"btnnextStep" + this.excelGridIndex}
            text={React.language("nextStep")}
            type={"blue"}
            click={(event) => {
              this.excelCheckData();
            }}
            mode={window.mode}
          />
          <BsyIconBtn
            key={"btnprevStep" + this.excelGridIndex}
            text={React.language("prevStep")}
            click={(event) => {
              // this.excelGetSample();
              this.setState({
                currentStep: 1,
                status: "dataPreview",
              });
            }}
            mode={window.mode}
          />
        </div>
      </div>
    );
  };

  bsyimporttipbar = () => {
    const { errorData } = this;
    var m = "";

    if (errorData.errorInfoFileUrl) {
      m = React.language("import.failTip.second", {
        tip1:
          '<a href="' +
          (errorData.errorInfoFileUrl || "") +
          '" class="text-green download" target="_blank">' +
          React.language("import.failTip.second.tip1") +
          "</a>",
        tip2: React.language("import.failTip.second.tip2"),
      });
    }
    if (errorData.errorCount + errorData.checkErrorCount > 60) {
      return (
        <>
          <div className="bsy-import-tip-bar">
            <div>{React.language("excel.export.tip15")}</div>
            <div dangerouslySetInnerHTML={{ __html: m }}></div>
          </div>
          <div className="bsy-import-tip-bar-line"></div>
        </>
      );
    } else {
      return (
        <>
          <div className="bsy-import-tip-bar">
            <div>
              {React.language("import.fail.count", {
                count: errorData.errorCount + errorData.checkErrorCount,
              })}
            </div>
            <div dangerouslySetInnerHTML={{ __html: m }}></div>
          </div>
          <div className="bsy-import-tip-bar-line"></div>
        </>
      );
    }
  };

  _getErrorItems = (error, header) => {
    var i = [];
    BsyUtils.forEach(error, (e, n) => {
      var a = {};
      BsyUtils.forEach(header, (e, t) => {
        var i = t.match && t.match.field;
        if (BsyUtils.isEmpty(n[i])) {
          if (t.subColumns && t.subColumns.length) {
            var s = {};
            a[t.col] = [];
            BsyUtils.forEach(t.subColumns, (e, t1) => {
              s[e] = "";
              if (e !== 0) {
                a[t.col + e] = "";
              }
            });
            a[t.col].push(s);
          } else a[t.col] = "";
        } else {
          if (t.subColumns && t.subColumns.length) {
            a[t.col] = [];
            var k = 0;
            //补齐列数据，后端返回的数据不完整
            BsyUtils.forEach(t.subColumns, function (key1, data) {
              if (k !== 0) {
                a[t.col + k] = "";
              }
              k++;
            });
            BsyUtils.forEach(n[i], function (e, i) {
              var n = {};
              BsyUtils.forEach(t.subColumns, function (e, t) {
                if (t.match && t.match.field) {
                  var a = t.match.field;
                  if (i[a]) {
                    if (Array.isArray(i[a])) {
                      for (var j = 0; j < i[a].length; j++) {
                        i[a][j].col = t.col;
                        i[a][j].text = i[a][j].name;
                      }
                      n[t.col] = {
                        col: t.col,
                        value: i[a],
                      };
                    } else {
                      n[t.col] = i[a]; // i[a].name
                      if (i[a].name) n[t.col].text = i[a].name;
                    }
                  } else {
                    n[t.col] = "";
                  }

                  // i[a] ? n[t.col] = i[a].name || i[a] : n[t.col] = ""
                } else n[t.col] = "";
              });
              a[t.col].push(n);
            });
          } else {
            if (n[i]) {
              if (Array.isArray(n[i])) {
                for (var j = 0; j < n[i].length; j++) {
                  n[i][j].col = t.col;
                  n[i][j].text = n[i][j].name;
                }
                a[t.col] = {
                  col: t.col,
                  value: n[i],
                };
              } else {
                a[t.col] = n[i]; // n[i].name || n[i]
                if (n[i].name) a[t.col].text = n[i].name;
              }
            } else {
              a[t.col] = "";
            }
            // n[i] ? a[t.col] = n[i].name || n[i] : a[t.col] = ""
          }
        }
      });
      i.push(a);
    });
    return i;
  };

  checkDataRepeat = (data, cb) => {
    const { appId, fileinfo, authGroupId, entryId, sheet } = this.state;

    React.axios("/dashboard/app/" + appId + "/excel/check_data_repeat", {
      authGroupId: authGroupId,
      cacheKey: fileinfo.cacheKey,
      entryId: entryId,
      extDashData: this.props.extDashData,
      sheetName: sheet || fileinfo.sheetList[0],
      ...data,
    })
      .then((res) => {
        cb && cb(res.data);
      })
      .catch((res) => {
        console.error(res);
        cb && cb({});
      });
  };

  renderCheckData = () => {
    const { hasSubform, matchHead, hasError } = this.state;
    const { errorData } = this;

    var c1 = matchHead.heads;
    var d1 = this._getErrorItems(this.errorData.error_data, matchHead.heads);

    return (
      <>
        {this.bsyimporttipbar()}
        <div
          className={"content"}
          key={"renderImportData" + this.excelGridIndex}
          style={{
            height: "calc(100% - 95px)",
          }}
        >
          <div className={"import-content "}>
            {errorData.errorCount + errorData.checkErrorCount > 60 ? (
              <div
                className="bsy-import-error-info"
                style={{
                  height: 370,
                }}
              >
                <div className="info-title">
                  {React.language("fail.detail")}
                </div>
                {errorData.users.miss.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("import.contact.emptyUser")}
                    </div>
                    <div className="info-text">
                      {errorData.users.miss.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.users.repeat.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip16")}
                    </div>
                    <div className="info-text">
                      {errorData.users.repeat.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.users.validity.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip17")}
                    </div>
                    <div className="info-text">
                      {errorData.users.validity.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.depts.miss.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("import.contact.emptyDept")}
                    </div>
                    <div className="info-text">
                      {errorData.depts.miss.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.depts.repeat.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip18")}
                    </div>
                    <div className="info-text">
                      {errorData.depts.repeat.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.widget.allowBlank.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip20")}
                    </div>
                    <div className="info-text">
                      {errorData.widget.allowBlank.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.widget.repeat.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip19")}
                    </div>
                    <div className="info-text">
                      {errorData.widget.repeat.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div
                className="bsy-import-excel"
                style={{
                  height: 370,
                }}
              >
                <BsyExcelGrid
                  getContext={(context) => {
                    this.checkDataExcelGridContext = context;
                  }}
                  key={"BsyExcelGrid-" + this.excelGridIndex}
                  hasSubform={hasSubform}
                  items={d1}
                  heads={c1}
                  showHead={true}
                  matchWidgets={this.formItems}
                  widgetsMap={this.widgetsMap}
                  formId={this.props.formId}
                  errorData={this.errorData.error_data}
                  onCheckData={(val, cb) => {
                    this.checkDataRepeat(val, cb);
                  }}
                  onUpdateError={() => {
                    if (this.checkDataExcelGridContext) {
                      let dd =
                        this.checkDataExcelGridContext.getFixedDataList();
                      // this.setState({
                      //     hasError: !!dd[0],
                      // })
                      this.nextImport.current.setVisible(dd[2] === 0);
                    }
                  }}
                  onAsyncSuccess={() => {
                    // that.columnMatch = [...this.excelGridContext.getColumnMatch(importCheckallowBlank, importCheckrepeat)]
                  }}
                ></BsyExcelGrid>
              </div>
            )}
          </div>
          <div className={"import-footer"}>
            <BsyIconBtn
              key={"btnnextStep" + this.excelGridIndex}
              ref={this.nextImport}
              text={React.language("nextStep")}
              type={"blue " + (hasError ? "bsy-ui-hidden" : "")}
              click={(event) => {
                this.excelImport();
              }}
              mode={window.mode}
            />

            <BsyIconBtn
              key={"btnprevStep" + this.excelGridIndex}
              text={React.language("prevStep")}
              click={(event) => {
                // this.excelMatchHead();
                this.setState({
                  currentStep: 2,
                  status: "formSet",
                });
              }}
              mode={window.mode}
            />
          </div>
        </div>
      </>
    );
  };

  renderImportData = () => {
    const { importMode, importData, name } = this.state;
    return (
      <div className={"content"} key={"renderImportData" + this.excelGridIndex}>
        <div className={"import-content "}>
          <div className="bsy-import-info">
            <div className="success">
              <i className="icon-right-circle"></i>
            </div>
            <div className="info">
              {importMode === 0
                ? React.language("import.success.count", {
                  count: importData.dataCount,
                  name: name,
                })
                : importMode === 1
                  ? React.language("import.update.finish.tip", {
                    count: importData.dataUpdateCount,
                  })
                  : importMode === 2
                    ? React.language("import.upsert.finish.tip", {
                      update: importData.dataUpdateCount,
                      add: importData.dataCount,
                    })
                    : ""}
            </div>
          </div>
        </div>
        <div className={"import-footer"}>
          <BsyIconBtn
            key={"btnnextStep" + this.excelGridIndex}
            text={React.language("done")}
            type={"blue"}
            click={(event) => {
              this.props.onFinish && this.props.onFinish();
              this.props.onClost && this.props.onClost();
            }}
            mode={window.mode}
          />
        </div>
      </div>
    );
  };

  renderContent = () => {
    const { status } = this.state;
    switch (status) {
      case "dataPreview":
        return this.renderDataPreview();
      case "formSet":
        return this.renderFormSet();
      case "checkData":
        return this.renderCheckData();
      case "importData":
        return this.renderImportData();
      case "selectExcel":
      default: {
        return this.renderSelectExcel();
      }
    }
  };

  render() {
    const { steps, currentStep, isLoading } = this.state;
    const { cssName } = this.options;
    this.excelGridIndex++;
    return (
      <div
        className={cssName + (isLoading ? " loading " : "")}
        ref={this.element}
      >
        {
          <BsyStepPane
            key={"step-" + new Date().getTime()}
            steps={steps}
            currentStep={currentStep}
          ></BsyStepPane>
        }
        {this.renderContent()}
        {isLoading && <BsySLoading />}
      </div>
    );
  }
}
